import flatpickr from "flatpickr";
// import confirmDatePlugin from "flatpickr/dist/plugins/confirmDate/confirmDate";

function RunStandardProcesses() {
	SetEditablePanelsForActivities();
	SetTextAreaAutoHeight();
}

function SetTextAreaAutoHeight() {
	const textareas = document.querySelectorAll("textarea");

	textareas.forEach(function (textarea) {
		textarea.addEventListener("dblclick", function () {
			const oldHeight = this.getAttribute("oldheight");
			// console.log({oldHeight});

			if (oldHeight) {
				this.style.height = oldHeight;
				this.removeAttribute("oldheight");
			} else {
				const currentHeight = window.getComputedStyle(this).height;
				this.setAttribute("oldheight", currentHeight);
				this.style.height = `${this.scrollHeight + 10}px`;
			}
		});
	});
}

function SetEditablePanelsForActivities() {
	let els = document.querySelectorAll(".PrasoraQuickEditDateActivityFixed[Loaded=false]");
	els.forEach((el) => {
		el.setAttribute("Loaded", "true");
		let pk = el.getAttribute("data-pk");
		// let dv = el.text;

		flatpickr(el, {
			showtime: false,
			// mode: null,
			dateFormat: "Y-m-d",
			// plugins: [new confirmDatePlugin({})],
			// defaultDate: el.text,
			onChange: (selectedDates, dateStr, instance) => {
				console.log({selectedDates, dateStr, instance});
				return $.ajax({
					type: "POST",
					url: "/api.aspx/QuickEditMethodCallForActivityFixed",
					data: JSON.stringify({pk: pk, name: "", value: dateStr}),
					contentType: "application/json; charset=utf-8",
					dataType: "json",
					async: true,
					cache: false,
					timeout: 10000,
					success: function (response) {
						UpdateAllActivityValues(response.d);
						$("[prasoraquickeditdateactivityfixedcheck][instid=" + instID + "]").attr("checked", true);
					},
				});
			},
		});
	});
}

export default RunStandardProcesses;
